import userReducer from "./users/users";
import successReducer from "./success/success";

const rootReducers = {
	user: userReducer,
	// cart: cartsReducer,
	// globalConfig: globalConfigReducer,
	successInfo: successReducer
};

export default rootReducers;